
import { SellerAccountModel } from "../models/SellerAccountModel";
import apiService from "./apiService";

const sellerAccountService = {
    updateSellerAccountProfile: async (firstName: string, lastName: string, contactNumber: string, timezone: string, countryCode: string) => {
        return await apiService.put(`/SellerAccount/Profile`, { firstName: firstName, lastName: lastName, contactNumber: contactNumber, timezone: timezone, countryCode: countryCode });
    },
    updateSellerAccountPassword: async (oldPassword: string, newPassword: string) => {
        return await apiService.put(`/SellerAccount/Password`, { oldPassword: oldPassword, newPassword: newPassword });
    },
    /**
     * 
     * @returns "TooFrequent", "EmailFailed", "Success" and "Error".
     */
    sendEmailVerification: async () => {
        return await apiService.post(`/SellerAccount/EmailVerification`, null);
    },
    /**
     * 
     * @param token 
     * @returns "InvalidToken", "TokenExpired", "Success" and "Error"
     */
    verifyEmail: async (token: string) => {
        return await apiService.put(
            `/SellerAccount/EmailVerified`,
            `"${token}"`, // wrap token in quotes so it's valid JSON
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },
    getSellerAccounts: async () => {
        const response = await apiService.get(`/SellerAccount`);
        return response.map((x: any) => new SellerAccountModel(x));
    },
    addSellerAccount: async ( username: string, password: string, firstName: string, lastName: string, timezone: string) => {
        return await apiService.post(`/SellerAccount`, {  username: username, password: password, firstname: firstName, lastname: lastName, timezone: timezone });
    },
    deleteSellerAccount: async (sellerAccountId: number) => {
        return await apiService.delete(`/SellerAccount/${sellerAccountId}`);
    }
}
export default sellerAccountService;